<template>
<b-card title="Filtros">
  <div class="row filter-column">
    <div class="col-md" v-bind:class="{ 'col-md-4': showFilterGrid }">
      <b-card-group columns>
        <b-card v-if="totalFilters===0">
          Sem filtros
        </b-card>
        <b-card v-show="filter.includes.length > 0 || filter.excludes.length > 0" no-body :key="filter.field" v-for="filter in readOptions.filters">
          <b-card-header>
            {{ filter.title }}
          </b-card-header>
          <b-list-group>
            <b-list-group-item variant="success" class="d-flex justify-content-between align-items-center" v-for="(item, index) in filter.includes" :key="item.id">
              {{ item.name }}
              <b-badge v-show="showFilterGrid" variant="danger" v-on:click="removeFilter(filter.field, index, 'includes')"><i class="fa fa-times"></i></b-badge>
            </b-list-group-item>
            <b-list-group-item variant="danger" class="d-flex justify-content-between align-items-center" v-for="(item, index) in filter.excludes" :key="item.id">
              {{ item.name }}
              <b-badge v-show="showFilterGrid" variant="danger" v-on:click="removeFilter(filter.field, index, 'excludes')"><i class="fa fa-times"></i>
              </b-badge>
            </b-list-group-item>
          </b-list-group>
          <b-card-footer>
            <a v-show="showFilterGrid" class="text-danger" v-on:click="removeAllFilters(filter.field)">Limpar filtros <i class="fa fa-ban"></i></a>
          </b-card-footer>
        </b-card>
      </b-card-group>
    </div>


    <div class="col-md-8" v-show="showFilterGrid">
      <b-card no-body>
        <b-card-header>
          <b-nav pills>
            <b-nav-item @click="changedFilter(filter.value, filter.name)" v-for="filter in filters" :key="filter.value" :active="type === filter.value">{{ filter.text }}</b-nav-item>
          </b-nav>
        </b-card-header>


        <GeneralFilter ref-name="SFMpg" v-show="type === 'mpg_id'" url="mpgs" v-on:added-filter="addFilter" name="MPG" field="mpg_id" />
        <GeneralFilter ref-name="SFBrand" v-show="type === 'brand_id'" url="brands" v-on:added-filter="addFilter" name="Brand" field="brand_id" />
        <GeneralFilter ref-name="SFCore" v-show="type === 'core_id'" url="cores" v-on:added-filter="addFilter" name="Cores" field="core_id" />

        <ProdAgreg v-show="type === 'product_aggregator_id'" v-on:added-filter="addFilter" />
        <Product v-show="type === 'product_id'" v-on:added-filter="addFilter" />

        <Client v-show="type === 'client_id'" v-on:added-filter="addFilter" />
        <GeneralFilter ref-name="SFOriginType" v-show="type === 'origin_type'" url="orderstype"  name="Tipo de Encomenda" v-on:added-filter="addFilter" field="origin_type" />
        <GeneralFilter ref-name="SFSalesPoint" v-show="type === 'sale_point'" url="salepoints"  name="Ponto de Venda" v-on:added-filter="addFilter" field="sale_point" />
        <GeneralFilter ref-name="SFZone" v-show="type === 'zone'" url="zones"  name="Zona" v-on:added-filter="addFilter" field="zone" />
        <GeneralFilter ref-name="SFOPGroup" v-show="type === 'operator_group_id'" url="operatorgroups"  name="Operator Groups" v-on:added-filter="addFilter" field="operator_group_id" />
        <GeneralFilter ref-name="SFActivity" v-show="type === 'activity_type_id'" url="activities"  name="Ramo Actividade" v-on:added-filter="addFilter" field="activity_type_id" />
        <GeneralFilter ref-name="SFLocation" v-show="type === 'location_id'" url="locations"  name="Localização" v-on:added-filter="addFilter" field="location_id" />
        <GeneralFilter ref-name="SFVisibility" v-show="type === 'visibility_id'" url="visibilities"  name="Visibilidade" v-on:added-filter="addFilter" field="visibility_id" />
        <GeneralFilter ref-name="SFSegment" v-show="type === 'segment_id'" url="segments"  name="Segmentos" v-on:added-filter="addFilter" field="segment_id" />

        <GeneralFilter ref-name="SFSalesTeam" v-show="type === 'salesteam_id'" url="team"  name="Vendedores" v-on:added-filter="addFilter" field="salesteam_id" />
        <Routine ref-name="SFRoutine" v-show="type === 'routine_code'" url="routines"  name="Rotina" v-on:added-filter="addFilter" field="routine_code" />
        <GeneralFilter ref-name="SFSalesteam2" v-show="type === 'salesteam_id2'" url="team"  name="Vendedores 2" v-on:added-filter="addFilter" field="salesteam_id2" />
        <Routine ref-name="SFRoutine2" v-show="type === 'routine_code2'" url="routines2"  name="Rotina 2" v-on:added-filter="addFilter" field="routine_code2" />
        <GeneralFilter ref-name="SFDoc" v-show="type === 'doc_type'" url="documentTypes"  name="Tipo Documento" v-on:added-filter="addFilter" field="doc_type" />

      </b-card>
    </div>
  </div>
</b-card>
</template>

<script>
import GeneralFilter from '@/views/Filters/Filter.vue'
import Mpg from '@/views/Filters/MpgFilter.vue'
import Brand from '@/views/Filters/BrandFilter.vue'
import Core from '@/views/Filters/CoreFilter.vue'
import ProdAgreg from '@/views/Filters/ProdAgregFilter.vue'
import Product from '@/views/Filters/ProductFilter.vue'
import Client from '@/views/Filters/ClientFilter.vue'
import Routine from '@/views/Filters/RoutineFilter.vue'
export default {
  name: 'Filters',
  components: {
    Mpg,
    GeneralFilter,
    Brand,
    ProdAgreg,
    Core,
    Product,
    Routine,
    Client
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data() {
    return {
      type: null,
      name: ''
    }
  },
  methods: {
    changedFilter(field, name) {
      this.type = field
      this.name = name
    },
    addFilter(evt) {
      var start = window.performance.now()
      console.log('event received', start)
      var found = false
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          })
          found = true
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          })
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          })
        }
      }
      console.log('added to list', window.performance.now())
      console.log('added to list elapsed', window.performance.now() - start)
    },
    removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1)
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1)
          }
        }
      }
    },
    removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = []
          this.readOptions.filters[i].excludes = []
        }
      }
    }
  },
  created() {

  }
}
</script>



// WEBPACK FOOTER //
// Filters.vue?5669ec5b